import OapDsfAppVtoWrapper from './code/Scripts/components/OapDsfAppVtoWrapper.vue';

export default {
  components: {
    OapDsfAppVtoWrapper,
  },
};
